export default __webpack_public_path__ + "static/media/reviews.d3730fad.png";